var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.5,
    stroke: "#2873F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89587 5.79166C8.20653 5.79166 8.45837 5.53982 8.45837 5.22916C8.45837 4.9185 8.20653 4.66666 7.89587 4.66666C7.58521 4.66666 7.33337 4.9185 7.33337 5.22916C7.33337 5.53982 7.58521 5.79166 7.89587 5.79166Z",
    fill: "#2873F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89587 7.47919V10.9792",
    stroke: "#2873F0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.f010c42daa03abe04b623cfbd77816e5.svg";
export { ForwardRef as ReactComponent };